import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import manutencao from '../../assets/Manutencao@3x.png';
import AppParagraph from '../app-paragraph';
import './styles.scss';

interface PageMaintenanceProps {
  isUnderMaintenance: boolean;
  isUnderMaintenanceMessage: string;
}

const PageMaintenance = ({
  isUnderMaintenance,
  isUnderMaintenanceMessage,
}: PageMaintenanceProps) => {
  const formatMessage = (text: string) => {
    return (
      <div>
        {text
          ?.split('\n')
          ?.filter((line: string) => line?.trim() !== '') // Remove empty lines
          ?.map((paragraph, index) => (
            <p key={index}>{paragraph?.trim()}</p>
          ))}
      </div>
    );
  };
  return (
    <>
      <div className="maintenance-container">
        <div className="maintenance-text">
          <p className="maintenance-text-title">Em manutenção</p>
          <img src={manutencao} className="img-manutencao" alt="Manutenção" />
          <p className="maintenance-text-subtitle">
            {formatMessage(isUnderMaintenanceMessage)}
          </p>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({
  isUnderMaintenance,
  isUnderMaintenanceMessage,
}: any) => ({
  isUnderMaintenance: isUnderMaintenance.value,
  isUnderMaintenanceMessage: isUnderMaintenanceMessage.value,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(PageMaintenance)
);
